<p class="mat-display-3">
  <ng-content></ng-content>
</p>
